export default __webpack_public_path__ + "static/media/Montserrat-Light.c3468d41.ttf";